<!-- 组件说明 -->
<template>
  <div class="shoppinglist-container">
    <div>
      <div class="con">
        <div class="banner"></div>
        <div v-if="goodsList.length > 0">
          <!-- 切换栏 -->
          <div class="list-header">
            <div class="title">
              <i></i>
              <span>预购商品</span>
            </div>
            <div class="listBtn">
              <div
                class="list c-pointer"
                :class="{ active: type == 1 }"
                @click="type = 1"
              >
                <img
                  :src="require('@/assets/images/icon_c1.png')"
                  v-if="type == 2"
                  alt=""
                />
                <img
                  :src="require('@/assets/images/icon_c2.png')"
                  v-else
                  alt=""
                />
                <span>列表</span>
              </div>
              <div
                class="table c-pointer"
                :class="{ active: type == 2 }"
                @click="type = 2"
              >
                <img
                  :src="require('@/assets/images/icon_d1.png')"
                  v-if="type == 1"
                  alt=""
                />
                <img
                  :src="require('@/assets/images/icon_d2.png')"
                  v-else
                  alt=""
                />
                <span>表格</span>
              </div>
            </div>
          </div>
          <!-- 商品列表 -->
          <goodslistceil2
            v-if="type == 1"
            :goodsList="goodsList"
          ></goodslistceil2>
          <goodslistceil v-else :goodsList="goodsList"></goodslistceil>
        </div>
        <div class="empty" v-if="goodsList.length == 0 && loaded">
          <div class="empty-img">
            <img :src="require('../../../assets/images/sousuo.png')" alt="" />
          </div>
          <div class="empty-con">
            <h5>暂无预购商品</h5>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import goodslistceil from "@/components/goods-list-ceil";
import goodslistceil2 from "@/components/goods-list-ceil-2";
export default {
  components: { goodslistceil, goodslistceil2 },
  data() {
    return {
      type: 1, //1列表  2表格
      goodsList: [],
      loaded: false,
    };
  },
  computed: {},
  methods: {
    getSpecialGoods(){
      let id = JSON.parse(localStorage.getItem('activityId')) 
      id && this.$api.POST_SPECIALGOODS({id}).then(res=>{
        if(res.status){
            this.goodsList =  res.data
        }
      })
    },
  },
  mounted() {},
  created() {
    this.getSpecialGoods();
  },
};
</script>

<style lang='scss' scoped>
.banner {
  height: 158px;
  width: 100%;
  background: url("../../../assets/images/seckill_banner.png") no-repeat;
  background-position: center;
}
.shoppinglist-container {
  min-height: calc(100vh - 252px);
}
.shopping-title {
  @include flex-d-c;
  align-items: center;
  margin: 40px 0 34px 0;
  h1 {
    font-size: 28px;
    color: #333333;
    font-weight: 400;
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    span {
      font-weight: bold;
    }
    &::before {
      content: "";
      display: inline-block;
      width: 18px;
      height: 1px;
      background-color: #e2e2e2;
      line-height: 40px;
      margin-right: 36px;
    }
    &::after {
      content: "";
      display: inline-block;
      width: 18px;
      height: 1px;
      background-color: #e2e2e2;
      line-height: 40px;
      margin-left: 36px;
    }
  }

  p {
    font-size: 12px;
    text-transform: uppercase;
    color: #ccc;
    margin: 0 0 14px;
  }
  i {
    display: block;
    width: 30px;
    height: 4px;
    background-color: #fa4b4b;
  }
}
.list-header {
  display: flex;
  justify-content: space-between;
  margin: 22px 0 24px 0;
}
.title {
  display: flex;
  align-items: center;
  i {
    display: inline-block;
    height: 18px;
    width: 4px;
    background-color: #fa4b4b;
    margin-right: 16px;
  }
}
.listBtn {
  display: flex;
  border-radius: 3px;
  .list,
  .table {
    width: 72px;
    height: 26px;
    @include font(13px, #666666, center, 400, 26px);
    img {
      margin-right: 5px;
    }
  }
  .list {
    border: 1px solid #eeeeee;
    border-radius: 3px 0 0 3px;
  }
  .table {
    border: 1px solid #eeeeee;
    border-radius: 0 3px 3px 0;
    img {
      margin-bottom: -1px;
    }
  }
}
.active {
  color: #f43737 !important;
  border-color: #f43737 !important;
}
.pagination {
  text-align: center;
  padding: 40px 0;
  color: #fa4b4b;
}
.empty {
  height: 260px;
  width: 1200px;
  background-color: #fdfdfd;
  border-radius: 10px;

  @include flex-c;
  .empty-img {
    margin-right: 35px;
  }
  .empty-con {
    @include flex-d-c;
    h5 {
      font-size: 18px;
      color: #505050;
      margin-bottom: 22px;
    }
    p {
      font-size: 16px;
      color: #808080;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/main/smActivityList/index.vue